<template>
  <transition name="back-to-top-fade">
    <div class="vue-back-to-top" v-show="visible" @click="backToTop">
      <slot>
        <div class="default">
          <i class="material-icons">arrow_upward</i>
          <span>
            Back To Top
          </span>
        </div>
      </slot>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'BackToTop',
  data () {
    return {
      visible: false
    }
  },
  /**
   * Catch window scroll event
   * @return {void}
   */
  created () {
    let catchScroll = () => {
      this.visible = (window.pageYOffset > 600)
    }

    window.smoothscroll = () => {
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll)
        window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)))
      }
    }

    window.onscroll = catchScroll
  },
  methods: {
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop () {
      window.smoothscroll()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../styles/_mixins.scss";
.back-to-top-fade-enter-active, .back-to-top-fade-leave-active {
  transition: opacity .7s;
}
.back-to-top-fade-enter, .back-to-top-fade-leave-to{
  opacity: 0;
}

.vue-back-to-top{
  position: fixed;
  z-index: 1000;
  cursor:pointer;
  top: 68px;
  left: 24px;
}

.vue-back-to-top .default {
  color: #232728;
  text-align: center;
  line-height: 30px;
  background-color: #ECECEC;
  border: 1px solid #D5D5D5;
  border-radius: 30px;
  padding: .125em .625em;
  @include bp(most) {
    padding: .125em 1.5em .125em 1.25em;
  }
  i {
    position: relative;
    font-size: 1.25em;
    top: 3px;
  }
}

.vue-back-to-top .default span {
  color:#232728;
  display: none;
  @include bp(most) {
    display: inline;
  }
}


</style>



// WEBPACK FOOTER //
// BackToTop.vue?c7bcd36e